import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'ownerSelect', 'usersContainer', 'groupsContainer' ]

  ownerChanged() {
    this.#updateSelectsVisibility()
  }

  #updateSelectsVisibility() {
    const value = this.ownerSelectTarget.value

    if (value === 'all') {
      this.usersContainerTarget.classList.add('d-none')
      this.groupsContainerTarget.classList.add('d-none')
    } else if (value === 'selected') {
      this.usersContainerTarget.classList.remove('d-none')
      this.groupsContainerTarget.classList.add('d-none')
    } else if (value === 'group') {
      this.usersContainerTarget.classList.add('d-none')
      this.groupsContainerTarget.classList.remove('d-none')
    }
  }
}